// Avatar Library Configuration
// This file contains metadata for all avatar images in the library

export interface AvatarImage {
    id: string
    filename: string
    category: AvatarCategory
    tags: string[]
    colorTone: 'cool' | 'warm' | 'neutral'
}

export type AvatarCategory =
    | 'all'
    | 'professional'
    | 'casual'
    | 'creative'

export const categoryLabels: Record<AvatarCategory, string> = {
    all: 'Todos',
    professional: 'Profissional',
    casual: 'Casual',
    creative: 'Criativo'
}

export const categoryDescriptions: Record<AvatarCategory, string> = {
    all: 'Todas as imagens disponíveis',
    professional: 'Imagens formais e corporativas',
    casual: 'Imagens descontraídas e informais',
    creative: 'Imagens artísticas e expressivas'
}

// Avatar library data
export const avatarLibrary: AvatarImage[] = [
    // Cool tones - Professional
    {
        id: 'avatar_001',
        filename: 'avatar-01.png',
        category: 'professional',
        tags: ['mulher', 'azul', 'formal', 'camisa'],
        colorTone: 'cool'
    },
    {
        id: 'avatar_002',
        filename: 'avatar-02.png',
        category: 'professional',
        tags: ['mulher', 'cinza', 'formal', 'blazer'],
        colorTone: 'neutral'
    },
    {
        id: 'avatar_003',
        filename: 'avatar-03.png',
        category: 'casual',
        tags: ['mulher', 'azul', 'lenço', 'acessórios'],
        colorTone: 'cool'
    },
    {
        id: 'avatar_004',
        filename: 'avatar-04.png',
        category: 'professional',
        tags: ['mulher', 'azul', 'formal', 'lenço'],
        colorTone: 'cool'
    },
    {
        id: 'avatar_005',
        filename: 'avatar-05.png',
        category: 'creative',
        tags: ['mulher', 'verde', 'óculos', 'casual'],
        colorTone: 'cool'
    },

    // Warm tones - Casual/Creative
    {
        id: 'avatar_006',
        filename: 'avatar-06.png',
        category: 'casual',
        tags: ['homem', 'laranja', 'moletom', 'óculos'],
        colorTone: 'warm'
    },
    {
        id: 'avatar_007',
        filename: 'avatar-07.png',
        category: 'casual',
        tags: ['homem', 'vermelho', 'jaqueta', 'esportivo'],
        colorTone: 'warm'
    },
    {
        id: 'avatar_008',
        filename: 'avatar-08.png',
        category: 'casual',
        tags: ['homem', 'laranja', 'boné', 'casual'],
        colorTone: 'warm'
    },
    {
        id: 'avatar_009',
        filename: 'avatar-09.png',
        category: 'casual',
        tags: ['homem', 'vermelho', 'camiseta', 'jovem'],
        colorTone: 'warm'
    },
    {
        id: 'avatar_010',
        filename: 'avatar-10.png',
        category: 'casual',
        tags: ['homem', 'branco', 'moletom', 'esportivo'],
        colorTone: 'neutral'
    },

    // Cool tones - Casual
    {
        id: 'avatar_011',
        filename: 'avatar-11.png',
        category: 'casual',
        tags: ['homem', 'verde', 'moletom', 'jovem'],
        colorTone: 'cool'
    },
    {
        id: 'avatar_012',
        filename: 'avatar-12.png',
        category: 'creative',
        tags: ['homem', 'rosa', 'casual', 'jovem'],
        colorTone: 'warm'
    },
    {
        id: 'avatar_013',
        filename: 'avatar-13.png',
        category: 'professional',
        tags: ['homem', 'verde', 'jaqueta', 'barba'],
        colorTone: 'cool'
    },
    {
        id: 'avatar_014',
        filename: 'avatar-14.png',
        category: 'casual',
        tags: ['homem', 'roxo', 'moletom', 'casual'],
        colorTone: 'cool'
    },
    {
        id: 'avatar_015',
        filename: 'avatar-15.png',
        category: 'casual',
        tags: ['homem', 'amarelo', 'moletom', 'jovem'],
        colorTone: 'warm'
    },

    // Cool tones - Professional/Casual mix
    {
        id: 'avatar_016',
        filename: 'avatar-16.png',
        category: 'casual',
        tags: ['homem', 'azul', 'suéter', 'casual'],
        colorTone: 'cool'
    },
    {
        id: 'avatar_017',
        filename: 'avatar-17.png',
        category: 'casual',
        tags: ['homem', 'azul', 'óculos', 'casual'],
        colorTone: 'cool'
    },
    {
        id: 'avatar_018',
        filename: 'avatar-18.png',
        category: 'professional',
        tags: ['homem', 'azul', 'camisa', 'formal'],
        colorTone: 'cool'
    },
    {
        id: 'avatar_019',
        filename: 'avatar-19.png',
        category: 'casual',
        tags: ['homem', 'verde', 'camiseta', 'barba'],
        colorTone: 'cool'
    },
    {
        id: 'avatar_020',
        filename: 'avatar-20.png',
        category: 'casual',
        tags: ['homem', 'verde', 'moletom', 'barba'],
        colorTone: 'cool'
    },

    // Warm tones - Creative
    {
        id: 'avatar_021',
        filename: 'avatar-21.png',
        category: 'creative',
        tags: ['mulher', 'amarelo', 'chapéu', 'casual'],
        colorTone: 'warm'
    },
    {
        id: 'avatar_022',
        filename: 'avatar-22.png',
        category: 'creative',
        tags: ['mulher', 'rosa', 'vermelho', 'casual'],
        colorTone: 'warm'
    },
    {
        id: 'avatar_023',
        filename: 'avatar-23.png',
        category: 'creative',
        tags: ['mulher', 'laranja', 'jaqueta', 'óculos'],
        colorTone: 'warm'
    },
    {
        id: 'avatar_024',
        filename: 'avatar-24.png',
        category: 'creative',
        tags: ['mulher', 'amarelo', 'blazer', 'formal'],
        colorTone: 'warm'
    },
    {
        id: 'avatar_025',
        filename: 'avatar-25.png',
        category: 'creative',
        tags: ['mulher', 'laranja', 'blazer', 'formal'],
        colorTone: 'warm'
    },

    // Cool tones - Creative/Professional
    {
        id: 'avatar_026',
        filename: 'avatar-26.png',
        category: 'professional',
        tags: ['mulher', 'roxo', 'blazer', 'formal'],
        colorTone: 'cool'
    },
    {
        id: 'avatar_027',
        filename: 'avatar-27.png',
        category: 'creative',
        tags: ['mulher', 'rosa', 'casual', 'jovem'],
        colorTone: 'warm'
    },
    {
        id: 'avatar_028',
        filename: 'avatar-28.png',
        category: 'creative',
        tags: ['mulher', 'roxo', 'casual', 'jovem'],
        colorTone: 'cool'
    },
    {
        id: 'avatar_029',
        filename: 'avatar-29.png',
        category: 'casual',
        tags: ['mulher', 'amarelo', 'casual', 'jovem'],
        colorTone: 'warm'
    },
    {
        id: 'avatar_030',
        filename: 'avatar-30.png',
        category: 'casual',
        tags: ['mulher', 'amarelo', 'casual', 'jovem'],
        colorTone: 'warm'
    }
]

// Helper functions
export function getAvatarsByCategory(category: AvatarCategory): AvatarImage[] {
    if (category === 'all') {
        return avatarLibrary
    }
    return avatarLibrary.filter(avatar => avatar.category === category)
}

export function searchAvatars(query: string): AvatarImage[] {
    const lowerQuery = query.toLowerCase().trim()
    if (!lowerQuery) return avatarLibrary

    return avatarLibrary.filter(avatar =>
        avatar.tags.some(tag => tag.toLowerCase().includes(lowerQuery)) ||
        avatar.category.toLowerCase().includes(lowerQuery) ||
        avatar.colorTone.toLowerCase().includes(lowerQuery)
    )
}

export function getAvatarUrl(filename: string): string {
    return `/avatars/library/${filename}`
}

export function getAvatarById(id: string): AvatarImage | undefined {
    return avatarLibrary.find(avatar => avatar.id === id)
}
